import { readToolField, useToolsMap } from '#plugin-chat/hooks/useToolsMap.ts';

/**
 * Read a typed field off a registered tool's entry in the assistant-ui
 * model context. The `<Tool>` component attaches metadata fields
 * (`display`, `message`, …) onto each entry; the chrome and the
 * transport read them back via this hook.
 *
 * Returns `undefined` when the tool isn't registered or the field is
 * absent — callers fall back to a default behaviour.
 *
 * Use the typed wrappers in this directory (`useToolDisplaySpec`,
 * `useToolMessage`) at call sites; reach for this generic helper only
 * when introducing a new attached field.
 */
export function useToolEntryField<T>(toolName: string | undefined, field: string): T | undefined {
  return readToolField<T>(useToolsMap(), toolName, field);
}
